import React, { useState, useContext } from "react";
import CarCard from "../../Components/CarCard";
import CallModal from "../../Components/CallModal";
import "./IndexCarGrid.css";
import { MyContext } from "../../Context/MyContext";

export default function HomeCarSection({ section }) {
  const { cars, home_page, getContactsForCar } = useContext(MyContext);

  const [selectedPartners, setSelectedPartners] = useState([]);
  const [showCallModal, setShowCallModal] = useState(false);

  const handleGetCall = (car) => {
    setSelectedPartners(getContactsForCar(car.sub_register_id));
    setShowCallModal(true);
  };

  const sectionCars = cars
    .filter((car) => car.home_show === true)
    .filter((car) => {
      const { is_modify, is_project } = section.filter;
      return car.is_modify === is_modify && (car.is_project || 0) === is_project;
    })
    .slice(0, home_page.cardLimit);

  if (!sectionCars.length) return null;

  return (
    <section className="premium-section">
      <h2 className="section-heading">
        {section.title} <span>{section.highlight}</span>
      </h2>

      <div className="simple-car-wrapper home-car-grid">
        {sectionCars.map((car) => (
          <CarCard key={car.id} car={car} onCall={handleGetCall} />
        ))}
      </div>

      {showCallModal && (
        <CallModal
          partners={selectedPartners}
          close={() => setShowCallModal(false)}
        />
      )}
    </section>
  );
}
